/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Collect_Cod_HintInputs */

const vi_order_form_collect_cod_hint = /** @type {(inputs: Order_Form_Collect_Cod_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế thu tiền khi giao đơn`)
};

/**

* @param {Order_Form_Collect_Cod_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_collect_cod_hint = /** @type {((inputs?: Order_Form_Collect_Cod_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Collect_Cod_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_collect_cod_hint(inputs)
});